"use client";

import { Button } from "@/components/ui/button";
import {
  HoverCard,
  HoverCardContent,
  HoverCardTrigger,
} from "@/components/ui/hover-card";
import { File as FileIcon, Paperclip } from "lucide-react";

export type TreePathAttachment = {
  id: string;
  name: string;
  path: string;
};

// Compact attachment summary with hover card for per-message attachments
export const MessageAttachmentsHover: React.FC<{ attachments: TreePathAttachment[] }> = ({
  attachments,
}) => {
  if (!attachments || attachments.length === 0) return null;

  return (
    <div className="mt-1">
      <HoverCard>
        <HoverCardTrigger asChild>
          <Button
            type="button"
            size="icon-sm"
            variant="ghost"
            className="text-muted-foreground hover:text-foreground"
          >
            <Paperclip className="h-4 w-4" />
            <span className="sr-only">Attachments</span>
          </Button>
        </HoverCardTrigger>
        <HoverCardContent className="w-80">
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <span className="text-xs font-medium text-muted-foreground">
                Attachments
              </span>
              <span className="text-[11px] text-muted-foreground">
                {attachments.length} total
              </span>
            </div>
            <div className="space-y-1.5 max-h-48 overflow-auto">
              {attachments.map((att) => (
                <div
                  key={att.id}
                  className="flex w-full items-center gap-2 rounded-md px-1.5 py-1 text-left text-xs hover:bg-muted/60 transition"
                >
                  <FileIcon className="h-3.5 w-3.5 text-muted-foreground flex-shrink-0" />
                  <div className="min-w-0">
                    <div className="truncate text-[11px] font-medium">
                      {att.name}
                    </div>
                    <div className="truncate text-[10px] text-muted-foreground">
                      {att.path}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </HoverCardContent>
      </HoverCard>
    </div>
  );
};

